import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "transfo-package-input"
}
const _hoisted_2 = { class: "field has-addons" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Derivative", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "field has-addons" }
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = { class: "button is-small is-static" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.layer)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "input is-small",
              placeholder: "Namespace",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.layer.namespace = $event))
            }, null, 512), [
              [_vModelText, _ctx.layer.namespace]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "input is-small",
              placeholder: "Version",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.layer.version = $event))
            }, null, 512), [
              [_vModelText, _ctx.layer.version]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              class: "select is-small is-expanded",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.layer.derivative = $event))
            }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDerivatives, (der) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: der,
                  value: der
                }, _toDisplayString(der), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.layer.derivative]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "button is-small",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search(_ctx.layer)))
            }, "Search")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", _hoisted_11, [
              (_ctx.pkgResult === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "?"))
                : _createCommentVNode("", true),
              (_ctx.pkgResult === false)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Not found"))
                : _createCommentVNode("", true),
              (_ctx.pkgResult)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.pkgResult), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}